"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.AvatarTextSmall = exports.AvatarText = exports.AvatarName = exports.AvatarContent = exports.AvatarContainer = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var AvatarContainer = (0, _styled.default)('div')(function () {
  return {
    display: 'flex',
    alignItems: 'center'
  };
});
exports.AvatarContainer = AvatarContainer;
var AvatarContent = (0, _styled.default)('div')(function (_ref) {
  var space = _ref.theme.space;
  return {
    padding: "0 ".concat(space.base),
    flex: 1
  };
});
exports.AvatarContent = AvatarContent;
var AvatarName = (0, _styled.default)('h4')(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      colors = _ref2$theme.colors,
      avatar = _ref2$theme.avatar,
      fonts = _ref2$theme.fonts,
      textStyles = _ref2$theme.textStyles;
  return _objectSpread(_objectSpread(_objectSpread({
    fontFamily: fonts[avatar.name.fontFamily]
  }, textStyles.headingText.quaternary.desktop), avatar.name.styles), {}, {
    color: colors[avatar.textColor],
    margin: 0
  });
});
exports.AvatarName = AvatarName;
var AvatarText = (0, _styled.default)('p')(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      avatar = _ref3$theme.avatar,
      textStyles = _ref3$theme.textStyles;
  return _objectSpread(_objectSpread({}, textStyles.globalText.desktop), {}, {
    color: avatar.textColor,
    marginBottom: 0
  });
});
exports.AvatarText = AvatarText;
var AvatarTextSmall = (0, _styled.default)('p')(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      fonts = _ref4$theme.fonts,
      avatar = _ref4$theme.avatar,
      textStyles = _ref4$theme.textStyles;
  return _objectSpread(_objectSpread(_objectSpread({
    fontFamily: fonts[avatar.textSmall.fontFamily]
  }, textStyles.globalText.mobile), avatar.textSmall.styles), {}, {
    color: colors[avatar.textSmall.textColor],
    margin: 0
  });
});
exports.AvatarTextSmall = AvatarTextSmall;